import { Box, ButtonProps, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";
import { SenecFunctionalIconButton } from "src/components/button/senec-functional-button/SenecFunctionalIconButton";
import { CloseIcon } from "src/foundations/icons";

export interface SenecIconDialogHeaderProps {
    icon?: ReactElement;
    title?: string;
    onClose: () => void;
    showCloseButton?: boolean;
    headerSize: "small" | "medium";
}

export const SenecIconDialogHeader = ({ icon, title, onClose, showCloseButton, headerSize }: SenecIconDialogHeaderProps) => {
    return (
        <Stack display={"flex"} direction={"row"} alignItems={"center"} spacing={2}>
            {icon}
            <Box sx={{ flexGrow: 1, width: "0" }}>
                {title && (
                    <Typography
                        data-testid={"desktop-title"}
                        variant={headerSize === "small" ? "h5" : "h4"}
                        sx={{
                            display: "-webkit-box",
                            overflow: "hidden",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 1,
                        }}
                    >
                        {title}
                    </Typography>
                )}
            </Box>
            {showCloseButton && <CloseButton onClick={onClose} sx={{ paddingLeft: "1rem" }} />}
        </Stack>
    );
};

const CloseButton = ({ onClick }: ButtonProps) => (
    <Box>
        <SenecFunctionalIconButton size={"small"} data-testid={"close-btn-id"} level={"tertiary"} onClick={onClick}>
            <CloseIcon />
        </SenecFunctionalIconButton>
    </Box>
);
